import apiClient from './api_client_requests';

export default async (payload) => {
    let result = await apiClient.apiMethod({
        method: 'PlayerLogin',
        args: {
            email: payload.email,
            password: payload.password,
        },
    });

    let player = result.user;
    let loggedIn = player ? true : false;
    if (loggedIn) {
        return {
            loggedIn: loggedIn,
            player: {
                name: player.first_name + ' ' + player.last_name,
                email: player.email,
                first_name: player.first_name,
                last_name: player.last_name,
                email_confirm: player.email,
            },
        };
    } else if (result.response) {
        return {
            loggedIn: false,
            errors: result.response.message,
        };
    } else {
        return {
            loggedIn: false,
            errors: 'Unspecified Error',
        };
    }
};
